import type { SpaceProps } from 'styled-system';
import { space } from 'styled-system';
import type { BaseComponentProps } from '../../interfaces/selection';

export interface VideoTileStyleProps extends SpaceProps, BaseComponentProps {
  /** Optional tag to render the component as a different HTML tag */
  tag?: any;
  id?: string;
}

export const baseStyles = ({ css }: VideoTileStyleProps) =>
  css ? `@media { ${css} };` : '';
export const baseSpacing = (props: VideoTileStyleProps) => space(props);
